import actionTypes from '../actions/action-types';

export default (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_RETAILER_REPORTS_SUCCESS:
      return [...action.items];
    case actionTypes.CLEAR_RETAILER_REPORTS:
      return [];
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/retailer-reports/reducers/items.js